module.exports = __webpack_public_path__ + "img/YE.b312301e.svg";